export default [
  'بیشتر از ۸۰۰ دقیقه مدیتیشن با عناوین منتخب',
  'بیشتر از ۶۰ جلسه تمرین فیتنس و فیزیکال تراپی',
  'مینی تمرینات ورزش و مدیتیشن روزانه و آپدیت هفتگی سایر دوره ها'
];
